<template>
  <div class="container">
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form ref="form" label-width="110px" class="info-form" style="margin-top: 22px" :rules="rules" :model="form">
        <el-form-item label="文章图片" prop="mainImg1">
          <upload-picture v-if="goodsArticleCategoryId == 1" :imageUrl="form.mainImg1" :width="'128px'" :height="'128px'"
            @getUrl="getImage"></upload-picture>
          <upload-picture1 v-else :limit="10" :isCustomer="1" :list="fileList" @changeImage="changeImage" />
        </el-form-item>
        <el-form-item label="视频" prop="video" v-if="goodsArticleCategoryId != 1">
          <upload-picture2 :imageUrl="form.video" :width="'108px'" :height="'108px'" @getUrl="getVideo"></upload-picture2>
          <!-- <upload-picture1 :limit="100000" :isCustomer="1" :list="fileList" @changeImage="changeImage" /> -->
        </el-form-item>

        <el-form-item label="文章标题" prop="title">
          <el-input placeholder="请输入文章标题" type="textarea" :rows="3" v-model="form.title" style="width: 442px"
            maxlength="200" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="文章内容" prop="content">
          <quill-editor v-model="form.content" ref="myQuillEditor" :options="editorOption" class="editor"></quill-editor>
          <div class="bottom" style="display: none">
            <el-upload class="centerImg" :action="' '" list-type="picture-card" :auto-upload="false"
              :on-change="handleAvatarChangeIcon" ref="uploadicon">
            </el-upload>
          </div>
        </el-form-item>
        <el-form label-width="100px">
          <el-form-item label="推荐商品">
            <el-button type="primary" @click="selectGoods">增加商品</el-button>
          </el-form-item>
          <el-form-item label=" " v-if="selectGoodsDatas.length > 0">
            <el-table :data="selectGoodsDatas" border :header-cell-style="{
              'text-align': 'center',
              background: '#F8F8F8',
              color: '#333333',
            }" :cell-style="{ 'text-align': 'center' }">
              <el-table-column label="商品类型" width="120">
                <template slot-scope="scope">
                  {{ scope.row.goodsType }}
                </template>
              </el-table-column>
              <el-table-column prop="code" label="商品编号"> </el-table-column>
              <el-table-column prop="name" label="商品名称"> </el-table-column>
              <el-table-column prop="goodsName" label="商品图片">
                <template slot-scope="scope">
                  <img :src="scope.row.mainImg" style="width:100px;height: 100px;" />
                </template>
              </el-table-column>
              <el-table-column prop="goodsName" label="状态">
                <template slot-scope="scope">
                  {{ scope.row.statusLabel }}
                </template>
              </el-table-column>
              <el-table-column prop="goodsName" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" style="color: red" @click="deleteG(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
      </el-form>
      <div style="height: 20px"></div>
      <div class="back-btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="primary" @click="save()">确认</el-button>
      </div>
    </div>

    <el-dialog title="选择商品" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogGoods" width="50%">
      <div style="height: 500px; overflow-y: auto">
        <div class="search-box" style="display:flex;justify-content:space-between">
          <div>
            <el-button :type="gType == '1' ? 'primary' : ''" size="small" @click="selectG('1')">普通商品</el-button>
            <el-button :type="gType == '2' ? 'primary' : ''" size="small" @click="selectG('2')">礼包商品</el-button>
          </div>
          <div>
            <el-input placeholder="请输入商品名称/商品编号" size="small" style="width: 224px; margin-right: 20px"
              v-model="goodsInfo"></el-input>
            <el-button type="primary" @click="fetchData('search')" size="small">查询</el-button>
          </div>

        </div>
        <el-table :data="goodsList" ref="multipleTable" @selection-change="handleSelectionChange" :show-header="false"
          border>
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column prop="goodsName" label="">
            <template slot-scope="scope">
              <div style="display: flex" v-if="gType == '1'">
                <img :src="scope.row.image" style="width: 72px; height: 56px; margin-right: 12px" alt="" />
                <div style="
                    font-size: 14px;
                    height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  ">
                  <p style="color: #333333">{{ scope.row.name }}</p>
                  <p style="color: #999999">
                    商品编号：{{ scope.row.goodsNo }}
                  </p>
                </div>
              </div>
              <div style="display: flex" v-else>
                <img :src="scope.row.images" style="width: 72px; height: 56px; margin-right: 12px" alt="" />
                <div style="
                    font-size: 14px;
                    height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  ">
                  <p style="color: #333333">{{ scope.row.name }}</p>
                  <p style="color: #999999">
                    商品编号：{{ scope.row.code }}
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="
            display: flex;
            justify-content: end;
            align-items: center;
            height: 42px;
          ">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
            :page-sizes="[5, 10, 20, 30]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum">
          </el-pagination>
        </div>
      </div>

      <div style="display: flex; justify-content: end; margin-top: 24px">
        <div class="info-q" @click="dialogGoods = false">取消</div>
        <div class="info-s" @click="selectD">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import uploadPicture from '@/components/upload/mallPicture.vue'
import uploadPicture1 from '@/components/upload/dragpicturew.vue'
import uploadPicture2 from '@/components/upload/uploadVideo.vue'
import { quillEditor } from 'vue-quill-editor'
import mixinsGoodsEditQuill from '../mixins/mixinsGoodsEditQuill.js'
import Quill from 'quill'
import imageResize from 'quill-image-resize-module' // 引用
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize) // 注册
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    uploadPicture,
    uploadPicture1,
    uploadPicture2,
    quillEditor
  },
  mixins: [mixinsGoodsEditQuill,],
  data() {
    return {
      editorOption: {},
      selectGoodsDatas: [],
      gType: '1',
      skus: [],
      stars: [

      ],
      goodsInfo: '',
      fileList: [],
      goodsList: [


      ],
      dialogGoods: false,
      radio: '1',
      startTime: [],
      expireDates: [

      ],
      dataList: {
        list: [
          { title: 'APP设置', path: '', type: '0' },
          { title: '礼道设置', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '新增文章', path: '', type: '0' }
        ]
      },
      checked1: true,
      checked2: false,
      radio: 3,
      name: '---',
      dialogUser: false,
      currentPage4: 1,
      tableData: [

      ],
      tableDataF: [

      ],
      detail: {},
      form: {
        goodsArticleCategoryId: '',
        id: '',
        mainImg: [],
        mainImg1: '',
        title: '',
        video: '',
        content: '',
        goodsIds: [],
        giftIds: [],
      },
      rules: {
        title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' },
        ],
        mainImg1: [
          { required: true, message: '请上传文章图片', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请输入文章内容', trigger: 'blur' },
        ],
      },
      arr: [],
      pageNo: 1,
      pageSize: 10,
      totalNum: 0,
      selectData: [],
      goodsArticleCategoryId: 1,
      goodsType: 1,
    }
  },
  created() {
    if (this.$route.query.goodsArticleCategoryId) {
      this.goodsArticleCategoryId = this.$route.query.goodsArticleCategoryId
    }
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id)
    }
  },

  methods: {
    selectG(val) {
      this.gType = val
      this.goodsInfo = ''
      if (val == 1) {
        this.getGList()
      } else {
        this.getGList1()
      }

    },
    deleteG(index) {
      this.selectGoodsDatas.splice(index, 1)
    },
    save() {
      console.log(this.form)
      this.form.goodsArticleCategoryId = this.goodsArticleCategoryId
      let ids = []
      this.selectGoodsDatas.forEach(item => {
        if (item.goodsType == '普通商品') {
          this.form.goodsIds.push(item.id)
        } else {
          this.form.giftIds.push(item.id)
        }
      })
      // this.selectGoodsDatas.forEach(item => {
      //   ids.push(item.id)
      // })
      // if (this.gType == 1) {
      //   this.form.goodsIds = ids
      // } else {
      //   this.form.giftIds = ids
      // }
      let arr = []
      if (this.goodsArticleCategoryId == 1) {
        arr.push(this.form.mainImg1)
      } else {
        this.fileList.forEach(item => {
          arr.push(item.url)
        })
      }

      this.form.mainImg = arr
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.axios.post('/goodsArticle/addEdit', this.form)
            .then(res => {
              console.log(res)
              if (res.code == 0) {
                this.$message.success('保存成功')
                this.$router.push({
                  name: 'ceremony',

                })
              }
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    selectD() {
      console.log(this.selectData)
      // this.selectGoodsDatas = this.selectData
      this.dialogGoods = false
      this.goodsType = this.gType
      let goodsIds = []
      let giftIds = []
      if (this.selectGoodsDatas) {
        this.selectGoodsDatas.forEach(item => {
          if (item.goodsType == '普通商品') {
            goodsIds.push(item.id)
          } else {
            giftIds.push(item.id)
          }
        })
      }
      if (this.gType == 1) {
        this.selectData.forEach(item => {
          goodsIds.push(item.id)
        })
      } else {
        this.selectData.forEach(item => {
          giftIds.push(item.id)
        })
      }
      let data = {
        goodsIds: goodsIds,
        giftIds: giftIds
      }
      this.axios.post('/goodsArticle/getGoodsArticleGoodsSelectedList', data).then(res => {
        if (res.code == 0) {
          this.selectGoodsDatas = res.data
        }
      })
      // if (this.gType == 1) {

      // } else {

      // }

    },
    changeImage(val) {
      this.fileList = val
      console.log(val)
      this.form.mainImg1 = this.fileList[0]
      this.$refs.form.clearValidate('mainImg1')
    },
    getImage(val) {
      console.log(val)
      this.form.mainImg1 = val
      this.$refs.form.clearValidate('mainImg1')
      this.$forceUpdate()
    },
    getVideo(val) {
      this.form.video = val
    },
    getGList() {
      let data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        nameOrGoodsNo: this.goodsInfo,
        status: 1
      }
      this.axios.post('/goods/pageList', data).then(res => {
        if (res.code == 0) {
          this.goodsList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    getGList1() {
      let data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        nameOrGoodsNo: this.goodsInfo,
        status: 1
      }
      this.axios.post('/giftPackage/pageList', data).then(res => {
        if (res.code == 0) {
          this.goodsList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    fetchData() {
      this.pageNo = 1
      if (this.gType == 1) {
        this.getGList()
      } else {
        this.getGList1()
      }

    },
    selectGoods() {
      console.log(88888888)
      this.dialogGoods = true
      if (this.gType == 1) {
        this.getGList()
      } else {
        this.getGList1()
      }


    },
    back() {
      this.$router.go(-1)
    },
    select() {
      console.log(this.arr)
    },
    getDetail() {
      this.axios.get('/goodsArticle/info?id=' + this.$route.query.id)
        .then(res => {
          if (res.code == 0) {
            this.form = res.data
            this.fileList = []
            this.selectGoodsDatas = []
            if (this.goodsArticleCategoryId == 1) {
              this.form.mainImg1 = res.data.mainImg[0]
            } else {
              res.data.mainImg.forEach(item => {
                let obj = {
                  url: item
                }
                this.fileList.push(obj)
              })
              this.form.mainImg1 = this.fileList[0]
            }
            if (res.data.goodsList) {
              // res.data.goodsList.forEach(item => {
              //   let obj = {
              //     id: item.id,
              //     name: item.name,
              //     statusLabel: item.statusLabel,
              //     image: item.mainImg,
              //     goodsNo: item.code,
              //   }
              //   this.selectGoodsDatas.push(obj)
              // })
              this.selectGoodsDatas = res.data.goodsList
            }
          }
        })
    },
    handleCurrentChange(e) {
      this.pageNo = e
      this.getGList()
    },
    handleSizeChange(e) {
      this.pageNo = 1
      this.pageSize = e
      this.getGList()
    },
    handleSelectionChange(e) {
      this.selectData = [];
      this.selectData = e
      // if (e.length > 1) {
      //   this.$refs.multipleTable.clearSelection();
      //   this.$refs.multipleTable.toggleRowSelection(
      //     e[e.length - 1]
      //   );
      // }
      // this.selectData = e[e.length - 1]
    }
  }
}
</script>
<style scoped lang="scss">
.messageI {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  // margin-top: 7px;
  color: #909099;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.search-box {
  width: 100%;
  height: 50px;
  background: #f8f8f8;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid #e8eaec;
  border-bottom: 0;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #ebeefa;
  border-color: #c0c0cc;
  color: #c0c4cc;
  cursor: not-allowed;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: left !important;
}

.detail {
  width: 378px;
  min-height: 82px;
  background: #ebeefa;
  opacity: 1;
  border-radius: 3px;
  padding: 10px 10px;
  line-height: 30px;
  color: #303033;
}

.s-label {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #303033;
  opacity: 1;
}

.start {
  width: 10px;
  height: 10px;
  background: #13ce4b;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}

.end {
  width: 10px;
  height: 10px;
  background: #f63c56;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}

.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}

.back-btn {
  width: 30%;
  text-align: left;
  padding-bottom: 20px;

  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }
}
</style>

